export default __webpack_public_path__ + "static/media/wrong_foods@2x.8c05b4fe.jpg";